import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // 基本
        background: '#F5E2F1',
        font_main: '#482C2C',
        // メイン見出し
        headline_second: '#482C2C',
        // ヘッダー
        header_bg: '#F5E2F1',
        header_font: '#482C2C',
        // フッター
        footer_bg: '#DEBFD7',
        footer_link: '#1C1C1C',
        // ボタン
        btn_main_bg: '#AE92ED',
        btn_main_font: '#FFFFFF',
        btn_main_gradation_first: '#E6C406',
        btn_main_gradation_second: '#AF7C0A',
        // 文字サイズ変更ボタン
        change_btn: '#fff',
        change_btn_invert: '#AE92ED',
        // テキストリンク
        link_main: '#3131D0',
        link_sub: '#F7FF39',
        // 鑑定師一覧・詳細
        actor_box_bg: '#FDF7FD',
        actor_box_font: '#482C2C',
        actor_box_border: '#B13F5F',
        // メールBOX一覧・鑑定ポイント一覧
        menu_list: '#FDF7FD',
        menu_list_font: '#482C2C',
        // メールBOX見出し
        mail_box_headline: '#DEBFD7',
        mail_box_headline_font: '#482C2C',
        // 通知バッジ
        badge: '#EA2D7D',
        badge_font: '#fff',
        // ポイント表
        table_head: '#DEBFD7',
        table_head_font: '#482C2C',
        table_body: '#FDF7FD',
        table_body_font: '#482C2C',
        // 無料占い結果
        horo_result_bg: '#00279E',
        horo_result_gradation_first: '#327C9D',
        horo_result_gradation_second: '#00279E',
        horo_result_border: '#AF4B4A',
        horo_result_font: '#fff',
        // 強調・注意表示部分
        emphasis: '#D97D88',
        caution: '#BE0A0A',
        font_annotation: '#fff',
        // その他テキスト
        error: '#AF404D',
        info: '#72bc88',
        success: '#72BC88',
        // 固定ページ
        page_headline: '1C1C1C',
        page_link: '#BE7A2A'
      }
    },
    options: { customProperties: true }
  }
})
